import { environment } from 'src/environments/environment';
import { Guid } from './guid';
import { PageRequest } from '../models/request.models';
import { Variables } from './variables';

declare const CryptoJS: any;

export class HelperFunctions {
  public static encryptAny(c: any): string {
    if (environment.production) {
      if (c) {
        return CryptoJS.AES.encrypt(JSON.stringify(c), Guid.generateS3()).toString();
      }
      return ''; // TODO: check if it's okay that I changed from null to empty string since TS is throwing type mismatch error
    }
    return JSON.stringify(c);
  }

  public static decryptAny(c: any): any {
    if (environment.production) {
      if (c) {
        const bytes = CryptoJS.AES.decrypt(c, Guid.generateS3());
        if (bytes.toString()) {
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        return JSON.parse(c);
      }
      return null;
    }
    return JSON.parse(c);
  }

  public static deepCopy<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }

  public static createInitPageRequest(pageSize: number = Variables.DEFAULT_PAGE_SIZE): PageRequest {
    return {
      size: pageSize,
      sort: [],
      page: 0,
      filters: [],
      criterias: [],
    };
  }
}
